import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {Counter} from '@/components/atoms';
import LabelWithTooltip from '@/components/atoms/LabelWithTooltip/LabelWithTooltip';
import {
  SURVEY_DISPLAY_ORDER_MAX,
  SURVEY_DISPLAY_ORDER_MIN,
  blockDisplayOrderKeyDown,
  normalizeDisplayOrderForCounter,
  sanitizeDisplayOrderInput
} from '@/utils/displayOrderValidation';

const DisplayOrderField = ({
  value,
  onUpdate,
  isInvalid,
  isInvalidFn,
  className = ''
}) => {
  const counterValue = normalizeDisplayOrderForCounter(value, isInvalidFn);

  const handleUpdate = useCallback(
    (nextValue) => {
      onUpdate(sanitizeDisplayOrderInput(nextValue));
    },
    [onUpdate]
  );

  return (
    <div
      className={`flex flex-col gap-2 ${className}`.trim()}
      data-testid='display-order-field'>
      <LabelWithTooltip
        className='text-[12px] text-[#d0d0d0]'
        label='Display Order'
      />
      <div onKeyDownCapture={blockDisplayOrderKeyDown}>
        <Counter
          feedbackType={isInvalid ? 'error' : 'info'}
          isDark
          value={counterValue}
          onUpdate={handleUpdate}
          minValue={SURVEY_DISPLAY_ORDER_MIN}
          maxValue={SURVEY_DISPLAY_ORDER_MAX}
          size='medium'
          className='w-20'
          style={{width: '76px'}}
        />
      </div>
    </div>
  );
};

DisplayOrderField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onUpdate: PropTypes.func.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  isInvalidFn: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default React.memo(DisplayOrderField);
